import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((cfg) => { try { cfg.headers["X-Device-Id"] = localStorage.getItem("wc_device_id") || ""; } catch { /* ignore */ } return cfg; });
client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wc_staff_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Staff auth
export const staffLogin = (email, password) => client.post("/auth/login", { email, password }).then((r) => { if (r.data.token) localStorage.setItem("wc_staff_token", r.data.token); return r.data; });
export const staffLogout = () => client.post("/auth/logout").finally(() => localStorage.removeItem("wc_staff_token"));
export const staffMe = () => client.get("/auth/me").then((r) => r.data);

// Bikes
export const getBikes = () => client.get("/bikes").then((r) => r.data);
export const getBike = (id) => client.get(`/bikes/${id}`).then((r) => r.data);
export const createBike = (data) => client.post("/bikes", data).then((r) => r.data);
export const updateBike = (id, data) => client.put(`/bikes/${id}`, data).then((r) => r.data);
export const deleteBike = (id) => client.delete(`/bikes/${id}`).then((r) => r.data);

// Hires
export const getHires = (params) => client.get("/hires", { params }).then((r) => r.data);
export const createHire = (data) => client.post("/hires", data).then((r) => r.data);
export const returnHire = (id) => client.post(`/hires/${id}/return`).then((r) => r.data);
export const deleteHire = (id) => client.delete(`/hires/${id}`).then((r) => r.data);

// Self-guided adventures
export const unlockRoute = (code, deviceId) =>
  client.post("/self-guided/unlock", { code, device_id: deviceId }).then((r) => r.data);
export const getSelfGuidedRoutes = () => client.get("/self-guided/routes").then((r) => r.data);
export const createSelfGuidedRoute = (data) => client.post("/self-guided/routes", data).then((r) => r.data);
export const deleteSelfGuidedRoute = (id) => client.delete(`/self-guided/routes/${id}`).then((r) => r.data);

// Access codes
export const listCodes = (routeId) => client.get(`/self-guided/routes/${routeId}/codes`).then((r) => r.data);
export const generateCodes = (routeId, count) => client.post(`/self-guided/routes/${routeId}/codes`, { count }).then((r) => r.data);
export const deleteCode = (codeId) => client.delete(`/self-guided/codes/${codeId}`).then((r) => r.data);
export const getActivations = (days = 14) => client.get("/self-guided/activations", { params: { days } }).then((r) => r.data);
export const reportLost = (data) => client.post("/self-guided/lost", data).then((r) => r.data);
export const getLostAlerts = () => client.get("/self-guided/lost").then((r) => r.data);
export const resolveLost = (id) => client.post(`/self-guided/lost/${id}/resolve`).then((r) => r.data);

// Stop voiceover audio
export const uploadStopAudio = (routeId, stopId, blob) => {
  const form = new FormData();
  form.append("file", blob, "voiceover.webm");
  return client.post(`/self-guided/routes/${routeId}/stops/${stopId}/audio`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const clearStopAudio = (routeId, stopId) =>
  client.delete(`/self-guided/routes/${routeId}/stops/${stopId}/audio`).then((r) => r.data);
export const editStop = (routeId, stopId, data) => client.put(`/self-guided/routes/${routeId}/stops/${stopId}`, data).then((r) => r.data);
export const editRouteNav = (routeId, data) => client.put(`/self-guided/routes/${routeId}/nav`, data).then((r) => r.data);
export const uploadCueAudio = (routeId, stopId, index, blob) => {
  const form = new FormData();
  form.append("stop_id", stopId); form.append("index", String(index)); form.append("file", blob, "cue.webm");
  return client.post(`/self-guided/routes/${routeId}/cue-audio`, form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const setStopDirections = (routeId, stopId, directions) =>
  client.put(`/self-guided/routes/${routeId}/stops/${stopId}/directions`, { directions }).then((r) => r.data);
export const uploadStopPhoto = (routeId, stopId, file) => {
  const form = new FormData();
  form.append("file", file, file.name || "photo.jpg");
  return client.post(`/self-guided/routes/${routeId}/stops/${stopId}/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const audioSrc = (rel) => `${process.env.REACT_APP_BACKEND_URL}${rel}`;

// Text to speech
export const generateTTS = (text, voice = "fable") =>
  client.post("/tts", { text, voice }).then((r) => r.data);
export const ttsUrl = (relativeUrl) => `${process.env.REACT_APP_BACKEND_URL}${relativeUrl}`;

// Dashboard
export const getStats = () => client.get("/dashboard/stats").then((r) => r.data);

// Bookings (Echo)
export const getWaiver = () => client.get("/waiver").then((r) => r.data);
export const saveWaiver = (text) => client.put("/waiver", { text }).then((r) => r.data);
export const createBooking = (data) => client.post("/bookings", data).then((r) => r.data);
export const getBooking = (id) => client.get(`/bookings/${id}`).then((r) => r.data);
export const startCheckout = (id) => client.post(`/bookings/${id}/checkout`, { origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const listBookings = () => client.get("/bookings").then((r) => r.data);
export const getBookingsCalendar = (month) => client.get("/bookings/calendar", { params: { month } }).then((r) => r.data);
export const getBookingAvailability = (date, start_time, hours) => client.get("/bookings/availability", { params: { date, start_time, hours } }).then((r) => r.data);
export const confirmBooking = (id) => client.post(`/bookings/${id}/confirm`).then((r) => r.data);
export const cancelBooking = (id) => client.post(`/bookings/${id}/cancel`).then((r) => r.data);
export const editBooking = (id, data) => client.put(`/bookings/${id}`, data).then((r) => r.data);
export const addExtraRider = (id, route_id) => client.post(`/bookings/${id}/extra-rider`, { route_id }).then((r) => r.data);
export const attachCode = (id, code, charge) => client.post(`/bookings/${id}/attach-code`, { code, charge }).then((r) => r.data);
export const markBookingPaid = (id, method, paid = true) => client.post(`/bookings/${id}/mark-paid`, { method, paid }).then((r) => r.data);
export const getOutbox = () => client.get("/outbox").then((r) => r.data);
export const getOutboxItem = (id) => client.get(`/outbox/${id}`).then((r) => r.data);
export const getEmailStatus = () => client.get("/email/status").then((r) => r.data);
export const sendRemindersNow = () => client.post("/bookings/reminders/send-now").then((r) => r.data);
export const sendReviewAsksNow = () => client.post("/bookings/review-asks/send-now").then((r) => r.data);
export const resendOutboxItem = (id) => client.post(`/outbox/${id}/resend`).then((r) => r.data);
export const resendAllUnsent = () => client.post("/outbox/resend-unsent").then((r) => r.data);
export const getShopInfo = () => client.get("/shop-info").then((r) => r.data);
export const saveShopInfo = (data) => client.put("/shop-info", data).then((r) => r.data);
export const getGuide = () => client.get("/guide").then((r) => r.data);
export const saveGuide = (text) => client.put("/guide", { text }).then((r) => r.data);
export const getEmailText = () => client.get("/email-text").then((r) => r.data);
export const getSecurityOverview = () => client.get("/security/overview").then((r) => r.data);
export const runPrivacyCleanup = () => client.post("/security/cleanup-now").then((r) => r.data);
export const postLocation = (data) => client.post("/self-guided/location", data).then((r) => r.data);
export const stopLocation = (route_id, device_id) => client.post("/self-guided/location/stop", { route_id, device_id }).then((r) => r.data);
export const getRiders = () => client.get("/self-guided/riders").then((r) => r.data);
export const searchCustomers = (q) => client.get("/customers/search", { params: { q } }).then((r) => r.data);
export const getCustomerRecord = (key) => client.post("/customers/record", key).then((r) => r.data);
export const exportCustomer = (key) => client.post("/customers/export", key, { responseType: "blob" }).then((r) => r.data);
export const deleteCustomer = (key) => client.post("/customers/delete", key).then((r) => r.data);
export const saveEmailText = (data) => client.put("/email-text", data).then((r) => r.data);
export const emailPreviewUrl = (kind) => `${API}/email/preview/${kind}`;

export default client;
